/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

// Utility function to manage media queries
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = (event) => setMatches(event.matches);

    // Use addEventListener instead of addListener
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      // Use removeEventListener instead of removeListener
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
};

function AppHidden({
  children,
  lgOnly,
  lgDown,
  mdOnly,
  mdDown,
  smOnly,
  smDown,
  xsOnly,
  xsDown,
  ...props
}) {
  // Define media queries for different breakpoints
  const breakpoints = {
    lgOnly: useMediaQuery('(min-width: 1280px)'), // lgOnly above 1280px
    lgDown: useMediaQuery('(max-width: 1279.98px)'), // lgDown below 1280px
    mdOnly: useMediaQuery('(min-width: 960px) and (max-width: 1279.98px)'), // mdOnly between 960px and 1280px
    mdDown: useMediaQuery('(max-width: 959.98px)'), // mdDown below 960px
    smOnly: useMediaQuery('(min-width: 600px) and (max-width: 959.98px)'), // smOnly between 600px and 960px
    smDown: useMediaQuery('(max-width: 599.98px)'), // smDown below 600px
    xsOnly: useMediaQuery('(min-width: 0px) and (max-width: 599.98px)'), // xsOnly between 0px and 600px
    xsDown: useMediaQuery('(max-width: 599.98px)'), // xsDown below 600px
  };

  // Conditionally render the component based on the props

  if (
    (lgOnly && !breakpoints.lgOnly) || // Show only in lg
    (lgDown && breakpoints.lgDown) || // Hide in lg
    (mdOnly && !breakpoints.mdOnly) || // Show only in md
    (mdDown && breakpoints.mdDown) || // Hide in md
    (smOnly && !breakpoints.smOnly) || // Show only in sm
    (smDown && breakpoints.smDown) || // Hide in sm
    (xsOnly && !breakpoints.xsOnly) || // Show only in xs
    (xsDown && breakpoints.xsDown) // Hide in xs
  ) {
    return null; // Remove from DOM if the condition isn't met
  }

  return <>{children}</>;
}

export default AppHidden;
